"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllFragSolUserData = void 0;
const constants_1 = require("../../constants");
const anchor_1 = require("@coral-xyz/anchor");
const getters_1 = require("../getters");
const helpers_1 = require("../../helpers");
const getAllFragSolUserData = (connection) => __awaiter(void 0, void 0, void 0, function* () {
    const fraktBondsOffset = 8;
    const bondTradeTxnOffset = 8;
    const hadoMarketOffset = 32 + 8;
    const program = (0, helpers_1.returnAnchorProgram)(connection);
    const hadoMarketsRaw = yield (0, getters_1.getFilteredAccounts)(program, 'hadoMarket', hadoMarketOffset, [3, 4]);
    const fraktBondsRaw = yield (0, getters_1.getFilteredAccounts)(program, 'fraktBond', fraktBondsOffset, [5]);
    const hadoMarkets = hadoMarketsRaw.map((hadoMarketRaw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(hadoMarketRaw));
    const bondTradeTransactionsActive = (yield (0, getters_1.getFilteredAccounts)(program, 'bondTradeTransactionV3', bondTradeTxnOffset, [2, 6, 7, 9, 11, 12, 13, 14])).map(helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings);
    const fraktBonds = fraktBondsRaw.map((fraktBondRaw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(fraktBondRaw));
    const wfragSolMarket = hadoMarkets.find((hadoMarket) => hadoMarket.publicKey.toString() === constants_1.WFRAGSOL_HADO_MARKET);
    const fragmetricFraktBonds = fraktBonds.filter((fraktBond) => fraktBond.fbondTokenMint.toString() === constants_1.WFRAGSOL_MINT).map(fraktBond => {
        const bondTradeTransaction = bondTradeTransactionsActive.find((bondTradeTransaction) => bondTradeTransaction.fbondTokenMint.toString() === fraktBond.fbondTokenMint.toString());
        if (!bondTradeTransaction) {
            return null;
        }
        const user = fraktBond.fbondIssuer;
        const originalDebt = bondTradeTransaction.solAmount.add(bondTradeTransaction.feeAmount);
        const borrowerApr = (0, helpers_1.calcBorrowerTokenAPR)(Number(bondTradeTransaction.amountOfBonds), Number(wfragSolMarket === null || wfragSolMarket === void 0 ? void 0 : wfragSolMarket.interestFee), true);
        const lendingTokenType = bondTradeTransaction.lendingToken;
        const [mutualBondTradeTxnVault] = anchor_1.web3.PublicKey.findProgramAddressSync([constants_1.ENCODER.encode(constants_1.MUTUAL_BOND_TRADE_TXN_VAULT), fraktBond.publicKey.toBuffer()], program.programId);
        return {
            user,
            originalDebt,
            currentDebt: originalDebt,
            BorrowerAPRBasePoints: borrowerApr,
            lendingTokenType,
            collateralVault: mutualBondTradeTxnVault,
        };
    }).filter((item) => item !== null);
    return {
        fragSolBorrowerAccountData: fragmetricFraktBonds,
    };
});
exports.getAllFragSolUserData = getAllFragSolUserData;
